import styles from "./AboutTeam.module.css";
import ashish from "./Ashish.jpg";
import tushar from "./Tushar.jpg";
import snehal from "./Snehal.jpg";
import atharva from "./Atharva.jpg";
import { Link } from "react-router-dom";

const AboutTeam = () => {
    return (
        <div className = {styles.body}>
            <div className = {styles.navbar}>
                <h1 className = {styles.title}>TEAM</h1>
                <Link to = "/" className = {styles.backButton}>Back to Home -&gt;</Link>
            </div>
            <div className = {styles.panel}>
                <div className = {styles.card}>
                    <img className = {styles.photo} src = {ashish} alt = "ashish"/>
                    <h2 className = {styles.name}>Ashish</h2>
                </div>
                <div className = {styles.card}>
                    <img className = {styles.photo} src = {tushar} alt = "ashish"/>
                    <h2 className = {styles.name}>Tushar</h2>
                </div>
                <div className = {styles.card}>
                    <img className = {styles.photo} src = {snehal} alt = "ashish"/>
                    <h2 className = {styles.name}>Snehal</h2>
                </div>
                <div className = {styles.card}>
                    <img className = {styles.photo} src = {atharva} alt = "ashish"/>
                    <h2 className = {styles.name}>Atharva</h2>
                </div>
            </div>
        </div>
    )
}

export default AboutTeam;